<template>
  <div>
    <CRUDCriteria :showReset="true" :showSearch="false" :showAdditionalActions="true">
      <template v-slot:criteriaRows>
        <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
          <v-row class="ma-n4">
            <v-col cols="3" class="pt-0 pb-0">
              <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
               :criteriaState="criteriaState" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <ClarionDateControl class="input-text-size" v-model="criteriaState.fromDate"
               :isToggle="false" @input="searchByTimeOutClarionDate" label="From Date" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <ClarionDateControl class="input-text-size" v-model="criteriaState.toDate"
                @input="searchByTimeOutClarionDate" :isToggle="false" label="To Date" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-autocomplete :items="overPayList" v-model="criteriaState.type"
               class="input-text-size" label="Overpayment Type" item-text="name"
               item-value="value" @change="searchByCriteria" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-autocomplete :items="paymentMethodList" v-model="criteriaState.paymentMethod"
               class="input-text-size" label="Payment Method" item-text="name"
               item-value="value" @change="searchByCriteria" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0 mt-n6">
              <v-autocomplete :items="userList"
                v-model="criteriaState.assignedTo"
                @change="searchByCriteria"
                class="input-text-size" label="Assigned To"
                  item-text="fullname" item-value="username" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0 mt-n6">
              <CommonDropDowns :isItTaxDistrict=true @change="dataFromCommonDropDowns" />
            </v-col>
            <v-col cols='4' class="pt-0 pb-0 mt-n6">
              <v-text-field class="input-text-size" label="Wildcard Search (Tax ID, Tax Amount)"
                v-model="criteriaState.widcardSearch" @input="searchByTimeOut"
                v-uppercase=globalSettingItem.conEverythingToCaps />
            </v-col>
            <v-col cols='3' class="pt-0 pb-0 mt-n6">
              <v-checkbox class="input-text-size" @change="searchByCriteria"
               v-model="criteriaState.resolved" :label="`Include Resolved`" />
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:additionalActions>
        <v-col cols="2" class="pt-0 tax-roll-criteria-pick-list-btn-col">
          <v-btn
            class="input-text-size tax-roll-criteria-pick-list-btn white-space-pre-line"
            id="taxRollCriteriaPickListBtn"
            text
            color="blue darken-1"
            @click="handleSync"
          >
            <span>Sync Warrant Status</span>
          </v-btn>
        </v-col>
      </template>
    </CRUDCriteria>
  </div>
</template>

<script>
import {
  mapMutations, mapGetters, mapState,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CRUDCriteria from '../../../../common/base/crud-2.0/CRUDCriteria.vue';
import CommonDropDowns from '../../../common-utils/CommonDropDowns.mixin.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../../../common-utils/constants';
import { makeCriteriaStateNullIfEmptyString } from '../../../common-utils/CommonTaxFunctionalities';
import GlobalToCaps from '../../../../../util/shared/GlobalToCaps.mixin.vue';
import {
  overpaymentsNRefundsDropDownList, overpaymentPaymentMethodDropDownList,
} from '../../../TaxInquiry/TaxInquiryUtils/TableHeaders.utils';
import '../../../../../assets/style.css';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      delayTimerId: null,
      overPayList: overpaymentsNRefundsDropDownList,
      paymentMethodList: overpaymentPaymentMethodDropDownList,
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'OverpaymentsNRefundsList',
    },
    userList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
    CommonDropDowns,
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible', 'criteria']),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList');
    },
    searchByTimeOutClarionDate(val) {
      clearTimeout(this.delayTimerId);
      if ((val && (val).includes('-')) || !val) {
        this.delayTimerId = setTimeout(async () => {
          this.searchByCriteria();
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
    handleSync() {
      this.$emit('handleSync');
    },
  },
};
</script>
